









import { OpportunityMembershipStatus, Level } from '@/models/opportunities';
import Vue from 'vue';

export default Vue.extend({
  name: 'OpportunityIcon',
  props: {
    level: {
      default: Level.Medium,
      type: String as () => Level,
    },
    status: {
      default: OpportunityMembershipStatus.None,
      type: String as () => OpportunityMembershipStatus,
    },
    isSmall: {
      default: false,
      type: Boolean,
    },
  },
});
